import { render } from "./LeftMenu.vue?vue&type=template&id=bd9c97e4&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"

import "./LeftMenu.vue?vue&type=style&index=0&id=bd9c97e4&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd9c97e4"]])

export default __exports__